import { withRouter } from 'react-router';
import type { InjectedRouter } from 'react-router';
import type { VoidFunctionComponent } from 'react';

type Props = {
  to: string;
  router: InjectedRouter;
  replace?: boolean;
};

/**
 * Redirects the user to the `to` prop as soon as this component is rendered.
 */
const Redirect: VoidFunctionComponent<Props> = ({
  to,
  replace: shouldReplaceURL,
  router,
}) => {
  if (shouldReplaceURL) {
    router.replace({ pathname: to });
  } else {
    router.push(to);
  }
  return null;
};

export default withRouter(Redirect);
